import Markdown from 'markdown-to-jsx'
import React from 'react'

import { cn } from '@/legacy-src/lib/utils'

import { Alert } from '@/src/domains/design-system/components/Alert'
import { ButtonLink, type ButtonLinkProps } from '@/src/domains/design-system/components/Button'

import Icon from './icons/Icon'

type Props = {
  text: string
  className?: string
  button?: Partial<ButtonLinkProps>
}

const WarningBox: React.FC<Props> = ({ text, button, className = '' }) => (
  <Alert
    variant="yellow"
    className={className}
    icon={<Icon icon="info" />}
    title={
      <div className="flex grow flex-wrap justify-between gap-4 tablet:flex-nowrap tablet:items-center">
        <Markdown
          options={{
            overrides: {
              p: {
                props: {
                  className: `last:mb-0`,
                },
              },
            },
          }}
        >
          {text}
        </Markdown>
        {button ? (
          <ButtonLink
            size="text"
            {...button}
            className={cn(
              'flex-shrink-0',
              {
                'hover:underline': (button.size ?? 'text') === 'text',
              },
              button.className,
            )}
          >
            {button.children ?? ''}
          </ButtonLink>
        ) : null}
      </div>
    }
  />
)

export default WarningBox
